/*
 *************************************************************************
 *  ADOBE CONFIDENTIAL
 *
 *  Copyright 2025 Adobe
 *  All Rights Reserved.
 *
 *  NOTICE:  All information contained herein is, and remains
 *  the property of Adobe and its suppliers, if any. The intellectual
 *  and technical concepts contained herein are proprietary to Adobe
 *  and its suppliers and are protected by all applicable intellectual
 *  property laws, including trade secret and copyright laws.
 *  Dissemination of this information or reproduction of this material
 *  is strictly forbidden unless prior written permission is obtained
 *  from Adobe.
 *************************************************************************
 */

import {Skeleton} from '@nest/utility/src/skeleton/Skeleton';
import './PlansSkeleton.scss';

export class PlansSkeleton extends Skeleton {
	static planCard(): string {
		return `
			<div class="skl-plan-card">
				<div class="skl-plan-card__header">
					<div class="skl-plan-card__icon">
						${this.image({aspect: '1/1'})}
					</div>
					<div class="skl-plan-card__title">
						${this.heading({level: 4})}
					</div>
				</div>
				<div class="skl-plan-card__features">
					${this.paragraph({lines: 4})}
				</div>
				<div class="skl-plan-card__pricing">
					${this.heading({level: 3})}
					${this.caption()}
				</div>
				<div class="skl-plan-card__actions">
					${this.buttons({count: 1, justify: {base: 'center'}})}
				</div>
			</div>
		`;
	}

	static toString(): string {
		return this.wrapper({
			className: 'skl-plans',
			children: `
				<div class="skl-plans__header">
					<div class="skl-plans__back-button">
						${this.buttons({count: 1, type: 'action'})}
					</div>
					<div class="skl-plans__title">
						${this.heading({level: 2})}
					</div>
				</div>
				<div class="skl-plans__card-grid">
					${[...Array(6).keys()].map(() => this.planCard()).join('')}
				</div>
				<div class="skl-plans__footer">
					${this.paragraph({lines: 2})}
				</div>
			`,
		});
	}
}
